import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  NavbarAdmin,
  Modal,
  Resizer,
} from "../../components/CustomComponent.js";
import THUMBNAIL from "../../assets/images/thumbnail.png";
export default class Tiers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: "หน้าแรก",

      tab_ln: "th",

      photo_index: [],
      photo_about: "",
      photo_standards: "",
      footer_index: "",

      th_message_index: "",
      th_title_about: "",
      th_message_about: "",
      th_title_about_2: "",
      th_message_about_2: "",
      th_title_about_3: "",
      th_message_about_3: "",
      th_title_standards: "",
      th_message_standards: "",
      th_title_standards_2: "",
      th_message_standards_2: "",
      th_title_standards_3: "",
      th_message_standards_3: "",
      th_fax_contact: "",
      th_phone_contact: "",
      th_email_contact: "",
      th_name_contact_1: "",
      th_address_contact_1: "",
      th_phone_contact_1: "",
      th_fax_contact_1: "",
      th_email_contact_1: "",
      th_website_contact_1: "",
      th_name_contact_2: "",
      th_address_contact_2: "",
      th_phone_contact_2: "",
      th_fax_contact_2: "",
      th_email_contact_2: "",
      th_website_contact_2: "",

      us_message_index: "",
      us_title_about: "",
      us_message_about: "",
      us_title_about_2: "",
      us_message_about_2: "",
      us_title_about_3: "",
      us_message_about_3: "",
      us_title_standards: "",
      us_message_standards: "",
      us_title_standards_2: "",
      us_message_standards_2: "",
      us_title_standards_3: "",
      us_message_standards_3: "",
      us_fax_contact: "",
      us_phone_contact: "",
      us_email_contact: "",
      us_name_contact_1: "",
      us_address_contact_1: "",
      us_phone_contact_1: "",
      us_fax_contact_1: "",
      us_email_contact_1: "",
      us_website_contact_1: "",
      us_name_contact_2: "",
      us_address_contact_2: "",
      us_phone_contact_2: "",
      us_fax_contact_2: "",
      us_email_contact_2: "",
      us_website_contact_2: "",

      jp_message_index: "",
      jp_title_about: "",
      jp_message_about: "",
      jp_title_about_2: "",
      jp_message_about_2: "",
      jp_title_about_3: "",
      jp_message_about_3: "",
      jp_title_standards: "",
      jp_message_standards: "",
      jp_title_standards_2: "",
      jp_message_standards_2: "",
      jp_title_standards_3: "",
      jp_message_standards_3: "",
      jp_fax_contact: "",
      jp_phone_contact: "",
      jp_email_contact: "",
      jp_name_contact_1: "",
      jp_address_contact_1: "",
      jp_phone_contact_1: "",
      jp_fax_contact_1: "",
      jp_email_contact_1: "",
      jp_website_contact_1: "",
      jp_name_contact_2: "",
      jp_address_contact_2: "",
      jp_phone_contact_2: "",
      jp_fax_contact_2: "",
      jp_email_contact_2: "",
      jp_website_contact_2: "",

      cn_message_index: "",
      cn_title_about: "",
      cn_message_about: "",
      cn_title_about_2: "",
      cn_message_about_2: "",
      cn_title_about_3: "",
      cn_message_about_3: "",
      cn_title_standards: "",
      cn_message_standards: "",
      cn_title_standards_2: "",
      cn_message_standards_2: "",
      cn_title_standards_3: "",
      cn_message_standards_3: "",
      cn_fax_contact: "",
      cn_phone_contact: "",
      cn_email_contact: "",
      cn_name_contact_1: "",
      cn_address_contact_1: "",
      cn_phone_contact_1: "",
      cn_fax_contact_1: "",
      cn_email_contact_1: "",
      cn_website_contact_1: "",
      cn_name_contact_2: "",
      cn_address_contact_2: "",
      cn_phone_contact_2: "",
      cn_fax_contact_2: "",
      cn_email_contact_2: "",
      cn_website_contact_2: "",
    };
  }

  async componentDidMount() {
    if(profile.ut !== "super_user"){
      window.location.href = "/admin/contact";
    }
    loading(false);
    if (!profile || profile?.ep < new Date().getTime()) {
      localStorage.removeItem("scp-profile");
      alert(
        "/login",
        "warning",
        "แจ้งเตือน",
        "Token หมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง"
      );
    } else {
      await this.Get();
    }
  }
  Get = async () => {
    loading(true);
    let response = await fetch(
      process.env.REACT_APP_API_URL + `/setting.json`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    let data = result || null;
    this.setState({ ...data });

    loading(false);
  };
  CreateUpdate = async () => {
    const {
      photo_index,
      photo_about,
      photo_standards,
      footer_index,

      th_message_index,
      th_title_about,
      th_message_about,
      th_title_about_2,
      th_message_about_2,
      th_title_about_3,
      th_message_about_3,
      th_title_standards,
      th_message_standards,
      th_title_standards_2,
      th_message_standards_2,
      th_title_standards_3,
      th_message_standards_3,
      th_fax_contact,
      th_phone_contact,
      th_email_contact,
      th_name_contact_1,
      th_address_contact_1,
      th_phone_contact_1,
      th_fax_contact_1,
      th_email_contact_1,
      th_website_contact_1,
      th_name_contact_2,
      th_address_contact_2,
      th_phone_contact_2,
      th_fax_contact_2,
      th_email_contact_2,
      th_website_contact_2,

      us_message_index,
      us_title_about,
      us_message_about,
      us_title_about_2,
      us_message_about_2,
      us_title_about_3,
      us_message_about_3,
      us_title_standards,
      us_message_standards,
      us_title_standards_2,
      us_message_standards_2,
      us_title_standards_3,
      us_message_standards_3,
      us_fax_contact,
      us_phone_contact,
      us_email_contact,
      us_name_contact_1,
      us_address_contact_1,
      us_phone_contact_1,
      us_fax_contact_1,
      us_email_contact_1,
      us_website_contact_1,
      us_name_contact_2,
      us_address_contact_2,
      us_phone_contact_2,
      us_fax_contact_2,
      us_email_contact_2,
      us_website_contact_2,

      jp_message_index,
      jp_title_about,
      jp_message_about,
      jp_title_about_2,
      jp_message_about_2,
      jp_title_about_3,
      jp_message_about_3,
      jp_title_standards,
      jp_message_standards,
      jp_title_standards_2,
      jp_message_standards_2,
      jp_title_standards_3,
      jp_message_standards_3,
      jp_fax_contact,
      jp_phone_contact,
      jp_email_contact,
      jp_name_contact_1,
      jp_address_contact_1,
      jp_phone_contact_1,
      jp_fax_contact_1,
      jp_email_contact_1,
      jp_website_contact_1,
      jp_name_contact_2,
      jp_address_contact_2,
      jp_phone_contact_2,
      jp_fax_contact_2,
      jp_email_contact_2,
      jp_website_contact_2,

      cn_message_index,
      cn_title_about,
      cn_message_about,
      cn_title_about_2,
      cn_message_about_2,
      cn_title_about_3,
      cn_message_about_3,
      cn_title_standards,
      cn_message_standards,
      cn_title_standards_2,
      cn_message_standards_2,
      cn_title_standards_3,
      cn_message_standards_3,
      cn_fax_contact,
      cn_phone_contact,
      cn_email_contact,
      cn_name_contact_1,
      cn_address_contact_1,
      cn_phone_contact_1,
      cn_fax_contact_1,
      cn_email_contact_1,
      cn_website_contact_1,
      cn_name_contact_2,
      cn_address_contact_2,
      cn_phone_contact_2,
      cn_fax_contact_2,
      cn_email_contact_2,
      cn_website_contact_2,
    } = this.state;
    loading(true);
    await fetch(process.env.REACT_APP_API_URL + `/setting.json`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        photo_index,
        photo_about,
        photo_standards,
        footer_index,

        th_message_index,
        th_title_about,
        th_message_about,
        th_title_about_2,
        th_message_about_2,
        th_title_about_3,
        th_message_about_3,
        th_title_standards,
        th_message_standards,
        th_title_standards_2,
        th_message_standards_2,
        th_title_standards_3,
        th_message_standards_3,
        th_fax_contact,
        th_phone_contact,
        th_email_contact,
        th_name_contact_1,
        th_address_contact_1,
        th_phone_contact_1,
        th_fax_contact_1,
        th_email_contact_1,
        th_website_contact_1,
        th_name_contact_2,
        th_address_contact_2,
        th_phone_contact_2,
        th_fax_contact_2,
        th_email_contact_2,
        th_website_contact_2,

        us_message_index,
        us_title_about,
        us_message_about,
        us_title_about_2,
        us_message_about_2,
        us_title_about_3,
        us_message_about_3,
        us_title_standards,
        us_message_standards,
        us_title_standards_2,
        us_message_standards_2,
        us_title_standards_3,
        us_message_standards_3,
        us_fax_contact,
        us_phone_contact,
        us_email_contact,
        us_name_contact_1,
        us_address_contact_1,
        us_phone_contact_1,
        us_fax_contact_1,
        us_email_contact_1,
        us_website_contact_1,
        us_name_contact_2,
        us_address_contact_2,
        us_phone_contact_2,
        us_fax_contact_2,
        us_email_contact_2,
        us_website_contact_2,

        jp_message_index,
        jp_title_about,
        jp_message_about,
        jp_title_about_2,
        jp_message_about_2,
        jp_title_about_3,
        jp_message_about_3,
        jp_title_standards,
        jp_message_standards,
        jp_title_standards_2,
        jp_message_standards_2,
        jp_title_standards_3,
        jp_message_standards_3,
        jp_fax_contact,
        jp_phone_contact,
        jp_email_contact,
        jp_name_contact_1,
        jp_address_contact_1,
        jp_phone_contact_1,
        jp_fax_contact_1,
        jp_email_contact_1,
        jp_website_contact_1,
        jp_name_contact_2,
        jp_address_contact_2,
        jp_phone_contact_2,
        jp_fax_contact_2,
        jp_email_contact_2,
        jp_website_contact_2,

        cn_message_index,
        cn_title_about,
        cn_message_about,
        cn_title_about_2,
        cn_message_about_2,
        cn_title_about_3,
        cn_message_about_3,
        cn_title_standards,
        cn_message_standards,
        cn_title_standards_2,
        cn_message_standards_2,
        cn_title_standards_3,
        cn_message_standards_3,
        cn_fax_contact,
        cn_phone_contact,
        cn_email_contact,
        cn_name_contact_1,
        cn_address_contact_1,
        cn_phone_contact_1,
        cn_fax_contact_1,
        cn_email_contact_1,
        cn_website_contact_1,
        cn_name_contact_2,
        cn_address_contact_2,
        cn_phone_contact_2,
        cn_fax_contact_2,
        cn_email_contact_2,
        cn_website_contact_2,
      }),
    });

    await fetch(process.env.REACT_APP_API_URL + `/updated.json`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ last_update: new Date().getTime() }),
    });
    alert("#", "success");
    loading(false);
  };
  render() {
    const {
      tab,
      tab_ln,
      photo_index,
      photo_about,
      photo_standards,
      footer_index,

      th_message_index,
      th_title_about,
      th_message_about,
      th_title_about_2,
      th_message_about_2,
      th_title_about_3,
      th_message_about_3,
      th_title_standards,
      th_message_standards,
      th_title_standards_2,
      th_message_standards_2,
      th_title_standards_3,
      th_message_standards_3,
      th_fax_contact,
      th_phone_contact,
      th_email_contact,
      th_name_contact_1,
      th_address_contact_1,
      th_phone_contact_1,
      th_fax_contact_1,
      th_email_contact_1,
      th_website_contact_1,
      th_name_contact_2,
      th_address_contact_2,
      th_phone_contact_2,
      th_fax_contact_2,
      th_email_contact_2,
      th_website_contact_2,

      us_message_index,
      us_title_about,
      us_message_about,
      us_title_about_2,
      us_message_about_2,
      us_title_about_3,
      us_message_about_3,
      us_title_standards,
      us_message_standards,
      us_title_standards_2,
      us_message_standards_2,
      us_title_standards_3,
      us_message_standards_3,
      us_fax_contact,
      us_phone_contact,
      us_email_contact,
      us_name_contact_1,
      us_address_contact_1,
      us_phone_contact_1,
      us_fax_contact_1,
      us_email_contact_1,
      us_website_contact_1,
      us_name_contact_2,
      us_address_contact_2,
      us_phone_contact_2,
      us_fax_contact_2,
      us_email_contact_2,
      us_website_contact_2,

      jp_message_index,
      jp_title_about,
      jp_message_about,
      jp_title_about_2,
      jp_message_about_2,
      jp_title_about_3,
      jp_message_about_3,
      jp_title_standards,
      jp_message_standards,
      jp_title_standards_2,
      jp_message_standards_2,
      jp_title_standards_3,
      jp_message_standards_3,
      jp_fax_contact,
      jp_phone_contact,
      jp_email_contact,
      jp_name_contact_1,
      jp_address_contact_1,
      jp_phone_contact_1,
      jp_fax_contact_1,
      jp_email_contact_1,
      jp_website_contact_1,
      jp_name_contact_2,
      jp_address_contact_2,
      jp_phone_contact_2,
      jp_fax_contact_2,
      jp_email_contact_2,
      jp_website_contact_2,

      cn_message_index,
      cn_title_about,
      cn_message_about,
      cn_title_about_2,
      cn_message_about_2,
      cn_title_about_3,
      cn_message_about_3,
      cn_title_standards,
      cn_message_standards,
      cn_title_standards_2,
      cn_message_standards_2,
      cn_title_standards_3,
      cn_message_standards_3,
      cn_fax_contact,
      cn_phone_contact,
      cn_email_contact,
      cn_name_contact_1,
      cn_address_contact_1,
      cn_phone_contact_1,
      cn_fax_contact_1,
      cn_email_contact_1,
      cn_website_contact_1,
      cn_name_contact_2,
      cn_address_contact_2,
      cn_phone_contact_2,
      cn_fax_contact_2,
      cn_email_contact_2,
      cn_website_contact_2,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <NavbarAdmin />
        <div className="body p-3 mt-3 pb-5 position-relative">
          <div className="d-flex justify-content-between">
            <h4 className="fw-bold mb-4">ตั้งค่าอื่นๆ</h4>
            <div
              className="border-primary rounded-4 d-flex"
              style={{ padding: 2 }}
            >
              <button
                className={`btn btn-${
                  tab_ln === "th" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab_ln: "th" });
                }}
              >
                ไทย
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${
                  tab_ln === "us" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab_ln: "us" });
                }}
              >
                อังกฤษ
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${
                  tab_ln === "jp" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab_ln: "jp" });
                }}
              >
                ญี่ปุ่น
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${
                  tab_ln === "cn" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab_ln: "cn" });
                }}
              >
                จีน
              </button>
            </div>
          </div>

          <div className="d-flex mb-3">
            <div
              className="border-primary rounded-4 d-flex"
              style={{ padding: 2 }}
            >
              <button
                className={`btn btn-${
                  tab === "หน้าแรก" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab: "หน้าแรก" });
                }}
              >
                หน้าแรก
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${
                  tab === "เกี่ยวกับบริษัท" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab: "เกี่ยวกับบริษัท" });
                }}
              >
                เกี่ยวกับบริษัท
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${
                  tab === "มาตรฐานและงานวิจัย" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab: "มาตรฐานและงานวิจัย" });
                }}
              >
                มาตรฐานและงานวิจัย
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${
                  tab === "ติดต่อเรา" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab: "ติดต่อเรา" });
                }}
              >
                ติดต่อเรา
              </button>
            </div>
          </div>

          <div>
            <div className="row">
              {tab_ln === "th" && (
                <div className="col-12 col-md-6">
                  {tab === "หน้าแรก" && (
                    <div className="w-100">
                      <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">รูปภาพปก</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="photo_index"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  photo_index: [
                                    ...photo_index,
                                    result.data.image.url,
                                  ],
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {photo_index.length !== 0 && (
                            <div className="d-flex flex-wrap">
                              {photo_index?.map((item, index) => (
                                <div className="hpx-100 wpx-100 rounded-3 border p-1 position-relative me-3 mb-3">
                                  <img
                                    alt="example"
                                    src={item}
                                    className="rounded-3"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <span
                                    className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                    style={{ right: -8, top: -8 }}
                                    onClick={() => {
                                      photo_index.splice(index, 1);
                                      this.setState({ photo_index });
                                    }}
                                  >
                                    {"\uf00d"}
                                  </span>
                                </div>
                              ))}
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_index")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                            </div>
                          )}
                          {photo_index.length === 0 && (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_index")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200
                                พิกเซล เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ข้อความปก</div>
                        <textarea
                          className="form-control"
                          placeholder="ข้อความปก.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({ th_message_index: e.target.value });
                          }}
                          value={th_message_index}
                        />
                      </div>
                      {/* <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">ฟุตเตอร์</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="footer_index"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  footer_index: result.data.image.url,
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {footer_index ? (
                            <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                              <img
                                alt="example"
                                src={footer_index}
                                className="rounded-3"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -12, top: -12 }}
                                onClick={() => {
                                  this.setState({ footer_index: "" });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("footer_index")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                                เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div> */}
                    </div>
                  )}
                  {tab === "เกี่ยวกับบริษัท" && (
                    <div className="w-100">
                      <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">รูปภาพ</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="photo_about"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  photo_about: result.data.image.url,
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {photo_about ? (
                            <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                              <img
                                alt="example"
                                src={photo_about}
                                className="rounded-3"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -12, top: -12 }}
                                onClick={() => {
                                  this.setState({ photo_about: "" });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_about")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                                เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ.."
                          onChange={(e) => {
                            this.setState({ th_title_about: e.target.value });
                          }}
                          value={th_title_about}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({ th_message_about: e.target.value });
                          }}
                          value={th_message_about}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 2</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 2.."
                          onChange={(e) => {
                            this.setState({ th_title_about_2: e.target.value });
                          }}
                          value={th_title_about_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 2</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 2.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              th_message_about_2: e.target.value,
                            });
                          }}
                          value={th_message_about_2}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 3</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 3.."
                          onChange={(e) => {
                            this.setState({ th_title_about_3: e.target.value });
                          }}
                          value={th_title_about_3}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 3</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 3.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              th_message_about_3: e.target.value,
                            });
                          }}
                          value={th_message_about_3}
                        />
                      </div>
                    </div>
                  )}
                  {tab === "มาตรฐานและงานวิจัย" && (
                    <div className="w-100">
                      <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">รูปภาพ</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="photo_standards"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  photo_standards: result.data.image.url,
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {photo_standards ? (
                            <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                              <img
                                alt="example"
                                src={photo_standards}
                                className="rounded-3"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -12, top: -12 }}
                                onClick={() => {
                                  this.setState({ photo_standards: "" });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_standards")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                                เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ.."
                          onChange={(e) => {
                            this.setState({
                              th_title_standards: e.target.value,
                            });
                          }}
                          value={th_title_standards}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              th_message_standards: e.target.value,
                            });
                          }}
                          value={th_message_standards}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 2</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 2.."
                          onChange={(e) => {
                            this.setState({
                              th_title_standards_2: e.target.value,
                            });
                          }}
                          value={th_title_standards_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 2</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 2.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              th_message_standards_2: e.target.value,
                            });
                          }}
                          value={th_message_standards_2}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 3</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 3.."
                          onChange={(e) => {
                            this.setState({
                              th_title_standards_3: e.target.value,
                            });
                          }}
                          value={th_title_standards_3}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 3</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 3.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              th_message_standards_3: e.target.value,
                            });
                          }}
                          value={th_message_standards_3}
                        />
                      </div>
                    </div>
                  )}
                  {tab === "ติดต่อเรา" && (
                    <div className="w-100">
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">แฟกซ์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="แฟกซ์.."
                          onChange={(e) => {
                            this.setState({ th_fax_contact: e.target.value });
                          }}
                          value={th_fax_contact}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เบอร์โทร</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เบอร์โทร.."
                          onChange={(e) => {
                            this.setState({ th_phone_contact: e.target.value });
                          }}
                          value={th_phone_contact}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">อีเมล</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล.."
                          onChange={(e) => {
                            this.setState({ th_email_contact: e.target.value });
                          }}
                          value={th_email_contact}
                        />
                      </div>
                      <hr />
                      <h4>ข้อมูลติดต่อที่ 1</h4>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ชื่อบริษัท</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ชื่อบริษัท.."
                          onChange={(e) => {
                            this.setState({
                              th_name_contact_1: e.target.value,
                            });
                          }}
                          value={th_name_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ที่อยู่</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ที่อยู่.."
                          onChange={(e) => {
                            this.setState({
                              th_address_contact_1: e.target.value,
                            });
                          }}
                          value={th_address_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เบอร์โทร</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เบอร์โทร.."
                          onChange={(e) => {
                            this.setState({
                              th_phone_contact_1: e.target.value,
                            });
                          }}
                          value={th_phone_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">แฟกซ์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="แฟกซ์.."
                          onChange={(e) => {
                            this.setState({ th_fax_contact_1: e.target.value });
                          }}
                          value={th_fax_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">อีเมล</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล.."
                          onChange={(e) => {
                            this.setState({
                              th_email_contact_1: e.target.value,
                            });
                          }}
                          value={th_email_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เว็บไซต์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เว็บไซต์.."
                          onChange={(e) => {
                            this.setState({
                              th_website_contact_1: e.target.value,
                            });
                          }}
                          value={th_website_contact_1}
                        />
                      </div>
                      <hr />
                      <h4>ข้อมูลติดต่อที่ 2</h4>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ชื่อบริษัท</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ชื่อบริษัท.."
                          onChange={(e) => {
                            this.setState({
                              th_name_contact_2: e.target.value,
                            });
                          }}
                          value={th_name_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ที่อยู่</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ที่อยู่.."
                          onChange={(e) => {
                            this.setState({
                              th_address_contact_2: e.target.value,
                            });
                          }}
                          value={th_address_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เบอร์โทร</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เบอร์โทร.."
                          onChange={(e) => {
                            this.setState({
                              th_phone_contact_2: e.target.value,
                            });
                          }}
                          value={th_phone_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">แฟกซ์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="แฟกซ์.."
                          onChange={(e) => {
                            this.setState({ th_fax_contact_2: e.target.value });
                          }}
                          value={th_fax_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">อีเมล</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล.."
                          onChange={(e) => {
                            this.setState({
                              th_email_contact_2: e.target.value,
                            });
                          }}
                          value={th_email_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เว็บไซต์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เว็บไซต์.."
                          onChange={(e) => {
                            this.setState({
                              th_website_contact_2: e.target.value,
                            });
                          }}
                          value={th_website_contact_2}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              {tab_ln === "us" && (
                <div className="col-12 col-md-6">
                  {tab === "หน้าแรก" && (
                    <div className="w-100">
                      <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">รูปภาพปก</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="photo_index"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  photo_index: [
                                    ...photo_index,
                                    result.data.image.url,
                                  ],
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {photo_index.length !== 0 && (
                            <div className="d-flex flex-wrap">
                              {photo_index?.map((item, index) => (
                                <div className="hpx-100 wpx-100 rounded-3 border p-1 position-relative me-3 mb-3">
                                  <img
                                    alt="example"
                                    src={item}
                                    className="rounded-3"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <span
                                    className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                    style={{ right: -8, top: -8 }}
                                    onClick={() => {
                                      photo_index.splice(index, 1);
                                      this.setState({ photo_index });
                                    }}
                                  >
                                    {"\uf00d"}
                                  </span>
                                </div>
                              ))}
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_index")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                            </div>
                          )}
                          {photo_index.length === 0 && (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_index")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200
                                พิกเซล เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ข้อความปก</div>
                        <textarea
                          className="form-control"
                          placeholder="ข้อความปก.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({ us_message_index: e.target.value });
                          }}
                          value={us_message_index}
                        />
                      </div>
                      {/* <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">ฟุตเตอร์</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="footer_index"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  footer_index: result.data.image.url,
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {footer_index ? (
                            <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                              <img
                                alt="example"
                                src={footer_index}
                                className="rounded-3"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -12, top: -12 }}
                                onClick={() => {
                                  this.setState({ footer_index: "" });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("footer_index")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                                เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div> */}
                    </div>
                  )}
                  {tab === "เกี่ยวกับบริษัท" && (
                    <div className="w-100">
                      <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">รูปภาพ</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="photo_about"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  photo_about: result.data.image.url,
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {photo_about ? (
                            <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                              <img
                                alt="example"
                                src={photo_about}
                                className="rounded-3"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -12, top: -12 }}
                                onClick={() => {
                                  this.setState({ photo_about: "" });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_about")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                                เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ.."
                          onChange={(e) => {
                            this.setState({ us_title_about: e.target.value });
                          }}
                          value={us_title_about}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({ us_message_about: e.target.value });
                          }}
                          value={us_message_about}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 2</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 2.."
                          onChange={(e) => {
                            this.setState({ us_title_about_2: e.target.value });
                          }}
                          value={us_title_about_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 2</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 2.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              us_message_about_2: e.target.value,
                            });
                          }}
                          value={us_message_about_2}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 3</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 3.."
                          onChange={(e) => {
                            this.setState({ us_title_about_3: e.target.value });
                          }}
                          value={us_title_about_3}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 3</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 3.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              us_message_about_3: e.target.value,
                            });
                          }}
                          value={us_message_about_3}
                        />
                      </div>
                    </div>
                  )}
                  {tab === "มาตรฐานและงานวิจัย" && (
                    <div className="w-100">
                      <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">รูปภาพ</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="photo_standards"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  photo_standards: result.data.image.url,
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {photo_standards ? (
                            <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                              <img
                                alt="example"
                                src={photo_standards}
                                className="rounded-3"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -12, top: -12 }}
                                onClick={() => {
                                  this.setState({ photo_standards: "" });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_standards")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                                เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ.."
                          onChange={(e) => {
                            this.setState({
                              us_title_standards: e.target.value,
                            });
                          }}
                          value={us_title_standards}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              us_message_standards: e.target.value,
                            });
                          }}
                          value={us_message_standards}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 2</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 2.."
                          onChange={(e) => {
                            this.setState({
                              us_title_standards_2: e.target.value,
                            });
                          }}
                          value={us_title_standards_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 2</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 2.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              us_message_standards_2: e.target.value,
                            });
                          }}
                          value={us_message_standards_2}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 3</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 3.."
                          onChange={(e) => {
                            this.setState({
                              us_title_standards_3: e.target.value,
                            });
                          }}
                          value={us_title_standards_3}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 3</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 3.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              us_message_standards_3: e.target.value,
                            });
                          }}
                          value={us_message_standards_3}
                        />
                      </div>
                    </div>
                  )}
                  {tab === "ติดต่อเรา" && (
                    <div className="w-100">
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">แฟกซ์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="แฟกซ์.."
                          onChange={(e) => {
                            this.setState({ us_fax_contact: e.target.value });
                          }}
                          value={us_fax_contact}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เบอร์โทร</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เบอร์โทร.."
                          onChange={(e) => {
                            this.setState({ us_phone_contact: e.target.value });
                          }}
                          value={us_phone_contact}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">อีเมล</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล.."
                          onChange={(e) => {
                            this.setState({ us_email_contact: e.target.value });
                          }}
                          value={us_email_contact}
                        />
                      </div>
                      <hr />
                      <h4>ข้อมูลติดต่อที่ 1</h4>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ชื่อบริษัท</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ชื่อบริษัท.."
                          onChange={(e) => {
                            this.setState({
                              us_name_contact_1: e.target.value,
                            });
                          }}
                          value={us_name_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ที่อยู่</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ที่อยู่.."
                          onChange={(e) => {
                            this.setState({
                              us_address_contact_1: e.target.value,
                            });
                          }}
                          value={us_address_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เบอร์โทร</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เบอร์โทร.."
                          onChange={(e) => {
                            this.setState({
                              us_phone_contact_1: e.target.value,
                            });
                          }}
                          value={us_phone_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">แฟกซ์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="แฟกซ์.."
                          onChange={(e) => {
                            this.setState({ us_fax_contact_1: e.target.value });
                          }}
                          value={us_fax_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">อีเมล</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล.."
                          onChange={(e) => {
                            this.setState({
                              us_email_contact_1: e.target.value,
                            });
                          }}
                          value={us_email_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เว็บไซต์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เว็บไซต์.."
                          onChange={(e) => {
                            this.setState({
                              us_website_contact_1: e.target.value,
                            });
                          }}
                          value={us_website_contact_1}
                        />
                      </div>
                      <hr />
                      <h4>ข้อมูลติดต่อที่ 2</h4>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ชื่อบริษัท</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ชื่อบริษัท.."
                          onChange={(e) => {
                            this.setState({
                              us_name_contact_2: e.target.value,
                            });
                          }}
                          value={us_name_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ที่อยู่</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ที่อยู่.."
                          onChange={(e) => {
                            this.setState({
                              us_address_contact_2: e.target.value,
                            });
                          }}
                          value={us_address_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เบอร์โทร</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เบอร์โทร.."
                          onChange={(e) => {
                            this.setState({
                              us_phone_contact_2: e.target.value,
                            });
                          }}
                          value={us_phone_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">แฟกซ์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="แฟกซ์.."
                          onChange={(e) => {
                            this.setState({ us_fax_contact_2: e.target.value });
                          }}
                          value={us_fax_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">อีเมล</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล.."
                          onChange={(e) => {
                            this.setState({
                              us_email_contact_2: e.target.value,
                            });
                          }}
                          value={us_email_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เว็บไซต์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เว็บไซต์.."
                          onChange={(e) => {
                            this.setState({
                              us_website_contact_2: e.target.value,
                            });
                          }}
                          value={us_website_contact_2}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              {tab_ln === "jp" && (
                <div className="col-12 col-md-6">
                  {tab === "หน้าแรก" && (
                    <div className="w-100">
                      <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">รูปภาพปก</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="photo_index"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  photo_index: [
                                    ...photo_index,
                                    result.data.image.url,
                                  ],
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {photo_index.length !== 0 && (
                            <div className="d-flex flex-wrap">
                              {photo_index?.map((item, index) => (
                                <div className="hpx-100 wpx-100 rounded-3 border p-1 position-relative me-3 mb-3">
                                  <img
                                    alt="example"
                                    src={item}
                                    className="rounded-3"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <span
                                    className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                    style={{ right: -8, top: -8 }}
                                    onClick={() => {
                                      photo_index.splice(index, 1);
                                      this.setState({ photo_index });
                                    }}
                                  >
                                    {"\uf00d"}
                                  </span>
                                </div>
                              ))}
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_index")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                            </div>
                          )}
                          {photo_index.length === 0 && (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_index")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200
                                พิกเซล เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ข้อความปก</div>
                        <textarea
                          className="form-control"
                          placeholder="ข้อความปก.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({ jp_message_index: e.target.value });
                          }}
                          value={jp_message_index}
                        />
                      </div>
                      {/* <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">ฟุตเตอร์</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="footer_index"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  footer_index: result.data.image.url,
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {footer_index ? (
                            <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                              <img
                                alt="example"
                                src={footer_index}
                                className="rounded-3"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -12, top: -12 }}
                                onClick={() => {
                                  this.setState({ footer_index: "" });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("footer_index")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                                เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div> */}
                    </div>
                  )}
                  {tab === "เกี่ยวกับบริษัท" && (
                    <div className="w-100">
                      <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">รูปภาพ</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="photo_about"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  photo_about: result.data.image.url,
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {photo_about ? (
                            <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                              <img
                                alt="example"
                                src={photo_about}
                                className="rounded-3"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -12, top: -12 }}
                                onClick={() => {
                                  this.setState({ photo_about: "" });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_about")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                                เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ.."
                          onChange={(e) => {
                            this.setState({ jp_title_about: e.target.value });
                          }}
                          value={jp_title_about}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({ jp_message_about: e.target.value });
                          }}
                          value={jp_message_about}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 2</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 2.."
                          onChange={(e) => {
                            this.setState({ jp_title_about_2: e.target.value });
                          }}
                          value={jp_title_about_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 2</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 2.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              jp_message_about_2: e.target.value,
                            });
                          }}
                          value={jp_message_about_2}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 3</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 3.."
                          onChange={(e) => {
                            this.setState({ jp_title_about_3: e.target.value });
                          }}
                          value={jp_title_about_3}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 3</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 3.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              jp_message_about_3: e.target.value,
                            });
                          }}
                          value={jp_message_about_3}
                        />
                      </div>
                    </div>
                  )}
                  {tab === "มาตรฐานและงานวิจัย" && (
                    <div className="w-100">
                      <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">รูปภาพ</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="photo_standards"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  photo_standards: result.data.image.url,
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {photo_standards ? (
                            <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                              <img
                                alt="example"
                                src={photo_standards}
                                className="rounded-3"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -12, top: -12 }}
                                onClick={() => {
                                  this.setState({ photo_standards: "" });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_standards")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                                เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ.."
                          onChange={(e) => {
                            this.setState({
                              jp_title_standards: e.target.value,
                            });
                          }}
                          value={jp_title_standards}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              jp_message_standards: e.target.value,
                            });
                          }}
                          value={jp_message_standards}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 2</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 2.."
                          onChange={(e) => {
                            this.setState({
                              jp_title_standards_2: e.target.value,
                            });
                          }}
                          value={jp_title_standards_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 2</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 2.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              jp_message_standards_2: e.target.value,
                            });
                          }}
                          value={jp_message_standards_2}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 3</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 3.."
                          onChange={(e) => {
                            this.setState({
                              jp_title_standards_3: e.target.value,
                            });
                          }}
                          value={jp_title_standards_3}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 3</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 3.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              jp_message_standards_3: e.target.value,
                            });
                          }}
                          value={jp_message_standards_3}
                        />
                      </div>
                    </div>
                  )}
                  {tab === "ติดต่อเรา" && (
                    <div className="w-100">
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">แฟกซ์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="แฟกซ์.."
                          onChange={(e) => {
                            this.setState({ jp_fax_contact: e.target.value });
                          }}
                          value={jp_fax_contact}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เบอร์โทร</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เบอร์โทร.."
                          onChange={(e) => {
                            this.setState({ jp_phone_contact: e.target.value });
                          }}
                          value={jp_phone_contact}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">อีเมล</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล.."
                          onChange={(e) => {
                            this.setState({ jp_email_contact: e.target.value });
                          }}
                          value={jp_email_contact}
                        />
                      </div>
                      <hr />
                      <h4>ข้อมูลติดต่อที่ 1</h4>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ชื่อบริษัท</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ชื่อบริษัท.."
                          onChange={(e) => {
                            this.setState({
                              jp_name_contact_1: e.target.value,
                            });
                          }}
                          value={jp_name_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ที่อยู่</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ที่อยู่.."
                          onChange={(e) => {
                            this.setState({
                              jp_address_contact_1: e.target.value,
                            });
                          }}
                          value={jp_address_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เบอร์โทร</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เบอร์โทร.."
                          onChange={(e) => {
                            this.setState({
                              jp_phone_contact_1: e.target.value,
                            });
                          }}
                          value={jp_phone_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">แฟกซ์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="แฟกซ์.."
                          onChange={(e) => {
                            this.setState({ jp_fax_contact_1: e.target.value });
                          }}
                          value={jp_fax_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">อีเมล</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล.."
                          onChange={(e) => {
                            this.setState({
                              jp_email_contact_1: e.target.value,
                            });
                          }}
                          value={jp_email_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เว็บไซต์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เว็บไซต์.."
                          onChange={(e) => {
                            this.setState({
                              jp_website_contact_1: e.target.value,
                            });
                          }}
                          value={jp_website_contact_1}
                        />
                      </div>
                      <hr />
                      <h4>ข้อมูลติดต่อที่ 2</h4>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ชื่อบริษัท</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ชื่อบริษัท.."
                          onChange={(e) => {
                            this.setState({
                              jp_name_contact_2: e.target.value,
                            });
                          }}
                          value={jp_name_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ที่อยู่</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ที่อยู่.."
                          onChange={(e) => {
                            this.setState({
                              jp_address_contact_2: e.target.value,
                            });
                          }}
                          value={jp_address_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เบอร์โทร</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เบอร์โทร.."
                          onChange={(e) => {
                            this.setState({
                              jp_phone_contact_2: e.target.value,
                            });
                          }}
                          value={jp_phone_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">แฟกซ์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="แฟกซ์.."
                          onChange={(e) => {
                            this.setState({ jp_fax_contact_2: e.target.value });
                          }}
                          value={jp_fax_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">อีเมล</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล.."
                          onChange={(e) => {
                            this.setState({
                              jp_email_contact_2: e.target.value,
                            });
                          }}
                          value={jp_email_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เว็บไซต์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เว็บไซต์.."
                          onChange={(e) => {
                            this.setState({
                              jp_website_contact_2: e.target.value,
                            });
                          }}
                          value={jp_website_contact_2}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              {tab_ln === "cn" && (
                <div className="col-12 col-md-6">
                  {tab === "หน้าแรก" && (
                    <div className="w-100">
                      <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">รูปภาพปก</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="photo_index"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  photo_index: [
                                    ...photo_index,
                                    result.data.image.url,
                                  ],
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {photo_index.length !== 0 && (
                            <div className="d-flex flex-wrap">
                              {photo_index?.map((item, index) => (
                                <div className="hpx-100 wpx-100 rounded-3 border p-1 position-relative me-3 mb-3">
                                  <img
                                    alt="example"
                                    src={item}
                                    className="rounded-3"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <span
                                    className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                    style={{ right: -8, top: -8 }}
                                    onClick={() => {
                                      photo_index.splice(index, 1);
                                      this.setState({ photo_index });
                                    }}
                                  >
                                    {"\uf00d"}
                                  </span>
                                </div>
                              ))}
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_index")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                            </div>
                          )}
                          {photo_index.length === 0 && (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_index")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200
                                พิกเซล เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ข้อความปก</div>
                        <textarea
                          className="form-control"
                          placeholder="ข้อความปก.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({ cn_message_index: e.target.value });
                          }}
                          value={cn_message_index}
                        />
                      </div>
                      {/* <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">ฟุตเตอร์</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="footer_index"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  footer_index: result.data.image.url,
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {footer_index ? (
                            <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                              <img
                                alt="example"
                                src={footer_index}
                                className="rounded-3"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -12, top: -12 }}
                                onClick={() => {
                                  this.setState({ footer_index: "" });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("footer_index")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                                เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div> */}
                    </div>
                  )}
                  {tab === "เกี่ยวกับบริษัท" && (
                    <div className="w-100">
                      <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">รูปภาพ</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="photo_about"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  photo_about: result.data.image.url,
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {photo_about ? (
                            <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                              <img
                                alt="example"
                                src={photo_about}
                                className="rounded-3"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -12, top: -12 }}
                                onClick={() => {
                                  this.setState({ photo_about: "" });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_about")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                                เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ.."
                          onChange={(e) => {
                            this.setState({ cn_title_about: e.target.value });
                          }}
                          value={cn_title_about}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({ cn_message_about: e.target.value });
                          }}
                          value={cn_message_about}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 2</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 2.."
                          onChange={(e) => {
                            this.setState({ cn_title_about_2: e.target.value });
                          }}
                          value={cn_title_about_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 2</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 2.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              cn_message_about_2: e.target.value,
                            });
                          }}
                          value={cn_message_about_2}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 3</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 3.."
                          onChange={(e) => {
                            this.setState({ cn_title_about_3: e.target.value });
                          }}
                          value={cn_title_about_3}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 3</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 3.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              cn_message_about_3: e.target.value,
                            });
                          }}
                          value={cn_message_about_3}
                        />
                      </div>
                    </div>
                  )}
                  {tab === "มาตรฐานและงานวิจัย" && (
                    <div className="w-100">
                      <div className="d-flex mb-2">
                        <div className="wpx-100 mb-2">รูปภาพ</div>
                        <div className="d-flex flex-wrap">
                          <input
                            hidden
                            accept="image/*"
                            id="photo_standards"
                            type="file"
                            onChange={async (e) => {
                              loading(true);
                              const file = e.target.files[0];
                              if (!file) return;

                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                const base64 = reader.result;
                                console.log(base64); // ✅ base64
                                // setState(base64) หรือส่งไป API ได้เลย
                                const formdata = new FormData();
                                formdata.append("image", base64.split(",")[1]);

                                const response = await fetch(
                                  "https://api.imgbb.com/1/upload?key=" +
                                    process.env.REACT_APP_IMGBB_KEY,
                                  {
                                    method: "POST",
                                    body: formdata,
                                  }
                                );

                                const result = await response.json();

                                this.setState({
                                  photo_standards: result.data.image.url,
                                });
                                loading(false);
                              };
                              reader.readAsDataURL(file);

                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                          {photo_standards ? (
                            <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                              <img
                                alt="example"
                                src={photo_standards}
                                className="rounded-3"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -12, top: -12 }}
                                onClick={() => {
                                  this.setState({ photo_standards: "" });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                                onClick={() => {
                                  document
                                    .getElementById("photo_standards")
                                    .click();
                                }}
                              >
                                {"\uf03e"}
                              </div>
                              <small className="text-secondary ps-3">
                                <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                                เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                                <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                                <br />
                                <b>ขนาดไฟล์สูงสุด:</b> 5MB
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ.."
                          onChange={(e) => {
                            this.setState({
                              cn_title_standards: e.target.value,
                            });
                          }}
                          value={cn_title_standards}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              cn_message_standards: e.target.value,
                            });
                          }}
                          value={cn_message_standards}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 2</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 2.."
                          onChange={(e) => {
                            this.setState({
                              cn_title_standards_2: e.target.value,
                            });
                          }}
                          value={cn_title_standards_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 2</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 2.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              cn_message_standards_2: e.target.value,
                            });
                          }}
                          value={cn_message_standards_2}
                        />
                      </div>
                      <hr />
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">หัวข้อ 3</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="หัวข้อ 3.."
                          onChange={(e) => {
                            this.setState({
                              cn_title_standards_3: e.target.value,
                            });
                          }}
                          value={cn_title_standards_3}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">รายละเอียด 3</div>
                        <textarea
                          className="form-control"
                          placeholder="รายละเอียด 3.."
                          rows={5}
                          onChange={(e) => {
                            this.setState({
                              cn_message_standards_3: e.target.value,
                            });
                          }}
                          value={cn_message_standards_3}
                        />
                      </div>
                    </div>
                  )}
                  {tab === "ติดต่อเรา" && (
                    <div className="w-100">
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">แฟกซ์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="แฟกซ์.."
                          onChange={(e) => {
                            this.setState({ cn_fax_contact: e.target.value });
                          }}
                          value={cn_fax_contact}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เบอร์โทร</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เบอร์โทร.."
                          onChange={(e) => {
                            this.setState({ cn_phone_contact: e.target.value });
                          }}
                          value={cn_phone_contact}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">อีเมล</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล.."
                          onChange={(e) => {
                            this.setState({ cn_email_contact: e.target.value });
                          }}
                          value={cn_email_contact}
                        />
                      </div>
                      <hr />
                      <h4>ข้อมูลติดต่อที่ 1</h4>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ชื่อบริษัท</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ชื่อบริษัท.."
                          onChange={(e) => {
                            this.setState({
                              cn_name_contact_1: e.target.value,
                            });
                          }}
                          value={cn_name_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ที่อยู่</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ที่อยู่.."
                          onChange={(e) => {
                            this.setState({
                              cn_address_contact_1: e.target.value,
                            });
                          }}
                          value={cn_address_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เบอร์โทร</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เบอร์โทร.."
                          onChange={(e) => {
                            this.setState({
                              cn_phone_contact_1: e.target.value,
                            });
                          }}
                          value={cn_phone_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">แฟกซ์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="แฟกซ์.."
                          onChange={(e) => {
                            this.setState({ cn_fax_contact_1: e.target.value });
                          }}
                          value={cn_fax_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">อีเมล</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล.."
                          onChange={(e) => {
                            this.setState({
                              cn_email_contact_1: e.target.value,
                            });
                          }}
                          value={cn_email_contact_1}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เว็บไซต์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เว็บไซต์.."
                          onChange={(e) => {
                            this.setState({
                              cn_website_contact_1: e.target.value,
                            });
                          }}
                          value={cn_website_contact_1}
                        />
                      </div>
                      <hr />
                      <h4>ข้อมูลติดต่อที่ 2</h4>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ชื่อบริษัท</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ชื่อบริษัท.."
                          onChange={(e) => {
                            this.setState({
                              cn_name_contact_2: e.target.value,
                            });
                          }}
                          value={cn_name_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">ที่อยู่</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ที่อยู่.."
                          onChange={(e) => {
                            this.setState({
                              cn_address_contact_2: e.target.value,
                            });
                          }}
                          value={cn_address_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เบอร์โทร</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เบอร์โทร.."
                          onChange={(e) => {
                            this.setState({
                              cn_phone_contact_2: e.target.value,
                            });
                          }}
                          value={cn_phone_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">แฟกซ์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="แฟกซ์.."
                          onChange={(e) => {
                            this.setState({ cn_fax_contact_2: e.target.value });
                          }}
                          value={cn_fax_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">อีเมล</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล.."
                          onChange={(e) => {
                            this.setState({
                              cn_email_contact_2: e.target.value,
                            });
                          }}
                          value={cn_email_contact_2}
                        />
                      </div>
                      <div className="d-flex mb-3">
                        <div className="wpx-100 mb-2">เว็บไซต์</div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="เว็บไซต์.."
                          onChange={(e) => {
                            this.setState({
                              cn_website_contact_2: e.target.value,
                            });
                          }}
                          value={cn_website_contact_2}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className="col-12 col-md-6">
                <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                <div style={{ zoom: 0.7 }}>
                  {tab === "หน้าแรก" && (
                    <div
                      className="w-100 text-white position-relative overflow-hidden"
                      style={{ minHeight: 600 }}
                    >
                      {/* Slides */}
                      {photo_index?.map((img, index) => (
                        <div
                          key={index}
                          className="hero-slide"
                          style={{
                            backgroundImage: `url(${img})`,
                          }}
                        />
                      ))}

                      {/* Gradient + Content */}
                      <div
                        className="position-relative align-content-center"
                        style={{
                          minHeight: 600,
                          background:
                            "linear-gradient(to right, rgba(0,0,0,0.8), rgba(0,0,0,0.2), rgba(0,0,0,0))",
                        }}
                      >
                        <div className="row container mx-auto">
                          <div className="col-12 col-md-8 col-xl-6 p-0">
                            <div className="px-4 mx-auto">
                              <h1 className="fw-bold mb-2">
                                บริษัท เอเชีย อีโค เอิร์ท จำกัด
                              </h1>
                              <h1 className="fw-bold mb-3">
                                ASIA ECO EARTH CO.,LTD.
                              </h1>
                              <h5 className="mb-3">
                                {this.state[tab_ln + "_message_index"] ||
                                  th_message_index}
                              </h5>

                              <button
                                className="btn btn-light px-4"
                                onClick={() =>
                                  this.setState({
                                    modal_quotation: true,
                                    full_name: "",
                                    email: "",
                                    phone: "",
                                    message: "",
                                  })
                                }
                              >
                                {global.i18[tab_ln]?.["ขอใบเสนอราคา"] ||
                                  "ขอใบเสนอราคา"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {tab === "เกี่ยวกับบริษัท" && (
                    <div
                      className="overflow-scroll w-100 py-4 bg-light"
                      style={{ maxHeight: "70vh" }}
                    >
                      {/* SECTION 1 */}
        <div
          className="w-100 text-white position-relative"
          style={{
            minHeight: 350,
            backgroundImage: `url(${require("../../assets/images/bg-5.jpg")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="text-center p-5 position-relative"
            style={{
              minHeight: 350,
            }}
          >
            <div className="w-100 d-flex justify-content-center mt-4">
              <div
                className="px-3 py-5 mt-4 rounded"
                style={{
                  backgroundColor: "rgba(0,0,0,0.3)",
                  maxWidth: 400,
                  minWidth: 300,
                  width: "70%",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)", // Safari
                }}
              >
                <h1 className="fw-bold mb-2">{global.i18[tab_ln]?.["เกี่ยวกับบริษัท"] || "เกี่ยวกับบริษัท"}</h1>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="w-100">
           <div className="row bg-secondary-light">
              <div className="col-12 col-md-6 col-lg-6">
                <div
                  className="d-none d-md-block position-relative align-content-center"
                  style={{
                    minHeight: 600,
                    backgroundImage: `
          linear-gradient(to left,
            rgba(248,249,250,1),
            rgba(248,249,250,0.2),
            rgba(248,249,250,0),
            rgba(248,249,250,0)
          ),
          url(${photo_about || THUMBNAIL})
        `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
                <div
                  className="d-block d-md-none position-relative align-content-center"
                  style={{
                    minHeight: 600,
                    backgroundImage: `
                      linear-gradient(to bottom,
                        rgba(248,249,250,1),
                        rgba(248,249,250,0.2),
                        rgba(248,249,250,0),
                        rgba(248,249,250,0),
                        rgba(248,249,250,0.2),
                        rgba(248,249,250,1)
                      ),
                      url(${photo_about || THUMBNAIL})
                    `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-6 text-start px-5">
                <div className="my-5 py-4">
                  <h2 className="fw-bold mb-4">{(this.state[tab_ln+"_title_about"] || th_title_about)}</h2>
                  <div className="text-secondary">{(this.state[tab_ln+"_message_about"] || th_message_about)}</div>
                </div>
              </div>
            </div>
          <div className="py-5">
            <div className="row mx-0">
              <div className="col-12 mb-4">
                <div className="bg-primary-light p-4 rounded-4">
                  <h4 className="fw-bold mb-2 text-primary text-center">{(this.state[tab_ln+"_title_about_2"] || th_title_about_2)}</h4>
                  <div className="text-secondary px-4">
                    {(this.state[tab_ln+"_message_about_2"] || th_message_about_2).split("\n").map((item) => (
                      <div>{item}</div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-12 mb-4">
                <div className="bg-primary-light p-4 rounded-4">
                <h4 className="fw-bold mb-2 text-primary text-center">{(this.state[tab_ln+"_title_about_3"] || th_title_about_3)}</h4>
                <div className="text-secondary px-4 text-center">
                  {(this.state[tab_ln+"_message_about_3"] || th_message_about_3).split("\n").map((item) => (
                    <div>{item}</div>
                  ))}
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
                    </div>
                  )}
                  {tab === "มาตรฐานและงานวิจัย" && (
                    <div
                      className="overflow-scroll w-100 py-4 bg-light"
                      style={{ maxHeight: "70vh" }}
                    >
                      {/* SECTION 1 */}
        <div
          className="w-100 text-white position-relative"
          style={{
            minHeight: 350,
            backgroundImage: `url(${require("../../assets/images/bg-3.jpg")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="text-center p-5 position-relative"
            style={{
              minHeight: 350,
            }}
          >
            <div className="w-100 d-flex justify-content-center mt-4">
              <div
                className="px-3 py-5 mt-4 rounded"
                style={{
                  backgroundColor: "rgba(0,0,0,0.3)",
                  maxWidth: 500,
                  minWidth: 300,
                  width: "70%",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)", // Safari
                }}
              >
                <h1 className="fw-bold mb-2">{global.i18[tab_ln]?.["มาตรฐานและงานวิจัย"] || "มาตรฐานและงานวิจัย"}</h1>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="w-100">
           <div className="row bg-secondary-light">
              <div className="col-12 col-md-6 col-lg-6">
                <div
                  className="d-none d-md-block position-relative align-content-center"
                  style={{
                    minHeight: 600,
                    backgroundImage: `
                      linear-gradient(to left,
                        rgba(248,249,250,1),
                        rgba(248,249,250,0.2),
                        rgba(248,249,250,0),
                        rgba(248,249,250,0)
                      ),
                      url(${photo_standards || THUMBNAIL})
                    `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
                <div
                  className="d-block d-md-none position-relative align-content-center"
                  style={{
                    minHeight: 600,
                    backgroundImage: `
                      linear-gradient(to bottom,
                        rgba(248,249,250,1),
                        rgba(248,249,250,0.2),
                        rgba(248,249,250,0),
                        rgba(248,249,250,0),
                        rgba(248,249,250,0.2),
                        rgba(248,249,250,1)
                      ),
                      url(${photo_standards || THUMBNAIL})
                    `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-6 text-start px-5">
                <div className="my-5 py-4">

                  <h2 className="fw-bold mb-4">{(this.state[tab_ln+"_title_standards"] || th_title_standards)}</h2>
                  <div className="text-secondary">{(this.state[tab_ln+"_message_standards"] || th_message_standards)}</div>
                  <div className="mt-3">
                    <button
                      className="btn btn-primary px-3 mb-3 mx-2"
                      onClick={() => { window.open("https://asiaecoearth.com/wp-content/uploads/2025/01/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AD%E0%B8%AD%E0%B8%81%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%9E%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%B2%E0%B9%80%E0%B8%95%E0%B8%B2%E0%B9%80%E0%B8%9C%E0%B8%B2%E0%B8%82%E0%B8%A2%E0%B8%B0%E0%B8%8A%E0%B8%B8%E0%B8%A1%E0%B8%8A%E0%B8%99%E0%B9%82%E0%B8%94%E0%B8%A2%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%A7%E0%B8%B4.pdf","_blank")}}
                    >
                      <b className="icon me-2">{"\uf019"}</b>
                      {global.i18[tab_ln]?.["ดาวน์โหลดงานวิจัย"] || "ดาวน์โหลดงานวิจัย"}
                    </button>
                    <br/>
                    <button
                      className="btn btn-success px-3 mb-3 mx-2"
                      onClick={() => { window.open("https://asiaecoearth.com/wp-content/uploads/2025/01/cert2023.pdf","_blank") }}
                    >
                      <b className="icon me-2">{"\uf279"}</b>
                      Bureau Veritas Certification ISO 9001:2015
                    </button>
                  </div>
                </div>
              </div>
            </div>
          <div className="py-5">
            <div className="row mx-0">
              <div className="col-12 mb-4">
                <div className="bg-primary-light p-4 rounded-4">
                  <h4 className="fw-bold mb-2 text-primary text-center">{(this.state[tab_ln+"_title_standards_2"] || th_title_standards_2)}</h4>
                  <div className="text-secondary px-4">
                    {(this.state[tab_ln+"_message_standards_2"] || th_message_standards_2).split("\n").map((item) => (
                      <div>{item}</div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-12 mb-4">
                <div className="p-4 rounded-4">
                <h4 className="fw-bold mb-2 text-primary">{(this.state[tab_ln+"_title_standards_3"] || th_title_standards_3)}</h4>
                <div className="text-secondary px-4">
                  {(this.state[tab_ln+"_message_standards_3"] || th_message_standards_3).split("\n").map((item) => (
                    <div>{item}</div>
                  ))}
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
                    </div>
                  )}
                  {tab === "ติดต่อเรา" && (
                    <div
                      className="overflow-scroll w-100"
                      style={{ maxHeight: "70vh" }}
                    >
                      {/* SECTION 1 */}
                              <div
                                className="w-100 text-white position-relative"
                                style={{
                                  minHeight: 350,
                                  backgroundImage: `url(${require("../../assets/images/bg-1.jpg")})`,
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                }}
                              >
                                <div
                                  className="text-center p-5 position-relative"
                                  style={{
                                    minHeight: 350,
                                  }}
                                >
                                  <div className="w-100 d-flex justify-content-center mt-4">
                                    <div
                                      className="px-3 py-5 mt-4 rounded"
                                      style={{
                                        backgroundColor: "rgba(0,0,0,0.3)",
                                        maxWidth: 400,
                                        minWidth: 300,
                                        width: "70%",
                                        backdropFilter: "blur(10px)",
                                        WebkitBackdropFilter: "blur(10px)", // Safari
                                      }}
                                    >
                                      <h1 className="fw-bold mb-2">ติดต่อเรา</h1>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* SECTION 2 */}
                              <div className="w-100 bg-secondary-light">
                                <div className="container mx-auto py-3 text-center">
                                  <div className="row">
                                    {(this.state[tab_ln + "_fax_contact"] || th_fax_contact) && (
                                      <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                                        <div className="p-3" style={{ minHeight: 212 }}>
                                          <span className="icon text-60 text-primary">
                                            {"\uf1ac"}
                                          </span>
                                          <h5 className="fw-bold mb-3">{global.i18[tab_ln]?.["โทรสาร"] || "โทรสาร"}</h5>
                                          <span className="text-secondary">{(this.state[tab_ln + "_fax_contact"] || th_fax_contact)}</span>
                                        </div>
                                      </div>
                                    )}
                                    {(this.state[tab_ln + "_phone_contact"] || th_phone_contact) && (
                                      <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                                        <div className="p-3" style={{ minHeight: 212 }}>
                                          <span className="icon text-60 text-primary">
                                            {"\uf095"}
                                          </span>
                                          <h5 className="fw-bold mb-3">{global.i18[tab_ln]?.["สำนักงานใหญ่"] || "สำนักงานใหญ่"}</h5>
                                          <span className="text-secondary">{(this.state[tab_ln + "_phone_contact"] || th_phone_contact)}</span>
                                        </div>
                                      </div>
                                    )}
                                    {(this.state[tab_ln + "_email_contact"] || th_email_contact) && (
                                      <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                                        <div className="p-3" style={{ minHeight: 212 }}>
                                          <span className="icon text-60 text-primary">
                                            {"\uf0e0"}
                                          </span>
                                          <h5 className="fw-bold mb-3">{global.i18[tab_ln]?.["อีเมล"] || "อีเมล"}</h5>
                                          <span className="text-secondary">{(this.state[tab_ln + "_email_contact"] || th_email_contact)}</span>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              {/* SECTION 3 */}
                              <div className="w-100 position-relative py-5">
                                <div className="container">
                                  <div className="row mx-0 pb-5">
                                    <div className="col-12 col-lg-6 mb-3">
                                      <div className="row">
                                        <div className="col-12 col-md-6 col-lg-12 mb-3 px-2">
                                            <h3 className="fw-bold mb-3">{(this.state[tab_ln + "_name_contact_1"] || th_name_contact_1)}</h3>
                                            {(this.state[tab_ln + "_address_contact_1"] || th_address_contact_1) && (
                                              <div className="d-flex align-items-center mb-3">
                                                <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                                  <h5 className="icon fw-bold text-22">{"\uf015"}</h5>
                                                </div>
                                                <div>
                                                  <b>{(this.state[tab_ln + "_name_contact_1"] || th_name_contact_1)}</b>
                                                  <br />
                                                  <span>{(this.state[tab_ln + "_address_contact_1"] || th_address_contact_1)}</span>
                                                </div>
                                              </div>
                                            )}
                                            {(this.state[tab_ln + "_phone_contact_1"] || th_phone_contact_1) && (
                                              <div className="d-flex align-items-center mb-3">
                                                <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                                  <h5 className="icon fw-bold text-22">{"\uf095"}</h5>
                                                </div>
                                                <div>
                                                  <b>{global.i18[tab_ln]?.["โทรได้ที่"] || "โทรได้ที่"}</b>
                                                  <br />
                                                  <span>{(this.state[tab_ln + "_phone_contact_1"] || th_phone_contact_1)}</span>
                                                </div>
                                              </div>
                                            )}
                                            {(this.state[tab_ln + "_fax_contact_1"] || th_fax_contact_1) && (
                                              <div className="d-flex align-items-center mb-3">
                                                <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                                  <h5 className="icon fw-bold text-22">{"\uf1ac"}</h5>
                                                </div>
                                                <div>
                                                  <b>{global.i18[tab_ln]?.["โทรสาร"] || "โทรสาร"}</b>
                                                  <br />
                                                  <span>{(this.state[tab_ln + "_fax_contact_1"] || th_fax_contact_1)}</span>
                                                </div>
                                              </div>
                                            )}
                                            {(this.state[tab_ln + "_email_contact_1"] || th_email_contact_1) && (
                                              <div className="d-flex align-items-center mb-3">
                                                <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                                  <h5 className="icon fw-bold text-22">{"\uf0e0"}</h5>
                                                </div>
                                                <div>
                                                  <b>{global.i18[tab_ln]?.["อีเมล"] || "อีเมล"}</b>
                                                  <br />
                                                  <span>{(this.state[tab_ln + "_email_contact_1"] || th_email_contact_1)}</span>
                                                </div>
                                              </div>
                                            )}
                                            {(this.state[tab_ln + "_website_contact_1"] || th_website_contact_1) && (
                                              <div className="d-flex align-items-center mb-3">
                                                <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                                  <h5 className="icon fw-bold text-22">{"\uf0ac"}</h5>
                                                </div>
                                                <div>
                                                  <b>{global.i18[tab_ln]?.["เว็บไซต์"] || "เว็บไซต์"}</b>
                                                  <br />
                                                  <span>{(this.state[tab_ln + "_website_contact_1"] || th_website_contact_1)}</span>
                                                </div>
                                              </div>
                                            )}
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-12 mb-3 px-2">
                                            <h3 className="fw-bold mb-3">{(this.state[tab_ln + "_name_contact_2"] || th_name_contact_2)}</h3>
                                            {(this.state[tab_ln + "_address_contact_2"] || th_address_contact_2) && (
                                              <div className="d-flex align-items-center mb-3">
                                                <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                                  <h5 className="icon fw-bold text-22">{"\uf015"}</h5>
                                                </div>
                                                <div>
                                                  <b>{(this.state[tab_ln + "_name_contact_2"] || th_name_contact_2)}</b>
                                                  <br />
                                                  <span>{(this.state[tab_ln + "_address_contact_2"] || th_address_contact_2)}</span>
                                                </div>
                                              </div>
                                            )}
                                            {(this.state[tab_ln + "_phone_contact_2"] || th_phone_contact_2) && (
                                              <div className="d-flex align-items-center mb-3">
                                                <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                                  <h5 className="icon fw-bold text-22">{"\uf095"}</h5>
                                                </div>
                                                <div>
                                                  <b>{global.i18[tab_ln]?.["โทรได้ที่"] || "โทรได้ที่"}</b>
                                                  <br />
                                                  <span>{(this.state[tab_ln + "_phone_contact_2"] || th_phone_contact_2)}</span>
                                                </div>
                                              </div>
                                            )}
                                            {(this.state[tab_ln + "_fax_contact_2"] || th_fax_contact_2) && (
                                              <div className="d-flex align-items-center mb-3">
                                                <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                                  <h5 className="icon fw-bold text-22">{"\uf1ac"}</h5>
                                                </div>
                                                <div>
                                                  <b>{global.i18[tab_ln]?.["โทรสาร"] || "โทรสาร"}</b>
                                                  <br />
                                                  <span>{(this.state[tab_ln + "_fax_contact_2"] || th_fax_contact_2)}</span>
                                                </div>
                                              </div>
                                            )}
                                            {(this.state[tab_ln + "_email_contact_2"] || th_email_contact_2) && (
                                              <div className="d-flex align-items-center mb-3">
                                                <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                                  <h5 className="icon fw-bold text-22">{"\uf0e0"}</h5>
                                                </div>
                                                <div>
                                                  <b>{global.i18[tab_ln]?.["อีเมล"] || "อีเมล"}</b>
                                                  <br />
                                                  <span>{(this.state[tab_ln + "_email_contact_2"] || th_email_contact_2)}</span>
                                                 </div>
                                              </div>
                                            )}
                                            {(this.state[tab_ln + "_website_contact_2"] || th_website_contact_2) && (
                                              <div className="d-flex align-items-center mb-3">
                                                <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                                  <h5 className="icon fw-bold text-22">{"\uf0ac"}</h5>
                                                </div>
                                                <div>
                                                  <b>{global.i18[tab_ln]?.["เว็บไซต์"] || "เว็บไซต์"}</b>
                                                  <br />
                                                  <span>{(this.state[tab_ln + "_website_contact_2"] || th_website_contact_2)}</span>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                      </div>
                                    </div>
                                    <div className="col-12 col-lg-6 py-5" id="input-message">
                                      <div className="card card-dashboard rounded-3 bg-secondary-light p-4 shadow-sm border-0">
                                        {/* <div className="d-flex justify-content-center align-items-center mb-4">
                                                 <div className="wpx-50 bg-danger" style={{ height: 2 }}></div>
                                                 <h6 className="text-danger mb-0 mx-3">ติดต่อเรา</h6>
                                                 <div className="wpx-50 bg-danger" style={{ height: 2 }}></div>
                                               </div> */}
                                        <div className="row">
                                          <div className="col-12">
                                            <div className="mb-2">{global.i18[tab_ln]?.["ชื่อ - นามสกุล"] || "ชื่อ - นามสกุล"}</div>
                                            <input
                                              className="form-control mb-3"
                                              type="text"
                                              placeholder={global.i18[tab_ln]?.["ชื่อ - นามสกุล"] || "ชื่อ - นามสกุล"}
                                            />
                                          </div>
                                          <div className="col-12">
                                            <div className="mb-2">{global.i18[tab_ln]?.["อีเมล"] || "อีเมล"}</div>
                                            <input
                                              className="form-control mb-3"
                                              type="email"
                                              placeholder={global.i18[tab_ln]?.["อีเมล"] || "อีเมล"}
                                            />
                                          </div>
                                          <div className="col-12">
                                            <div className="mb-2">{global.i18[tab_ln]?.["เบอร์โทรศัพท์"] || "เบอร์โทรศัพท์"}</div>
                                            <input
                                              className="form-control mb-3"
                                              type="text"
                                              placeholder={global.i18[tab_ln]?.["เบอร์โทรศัพท์"] || "เบอร์โทรศัพท์"}
                                              maxLength={10}
                                            />
                                          </div>
                                          <div className="col-12">
                                            <div className="mb-2">{global.i18[tab_ln]?.["ข้อความที่ต้องการติดต่อ"] || "ข้อความที่ต้องการติดต่อ"}</div>
                                            <textarea
                                              className="form-control mb-3"
                                              rows={8}
                                              placeholder={global.i18[tab_ln]?.["ข้อความที่ต้องการติดต่อ"] || "ข้อความที่ต้องการติดต่อ"}
                                            />
                                          </div>
                                          <div className="col-12">
                                            <button
                                              className="btn btn-primary px-5 w-100"
                                            >
                                              {global.i18[tab_ln]?.["ส่งข้อความ"] || "ส่งข้อความ"}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="hpx-50" />
          <div
            className="position-fixed px-4 py-3 bg-white w-100"
            style={{ bottom: 0, left: 0 }}
          >
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
